// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__KgX69"};